import { App as CapApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { NativeMarket } from '@capacitor-community/native-market';

export const checkForceUpdate = async (currentVersion, minVersion, isUpdateRequired) => {
  try {
    const info = await CapApp.getInfo();
    const installedVersion = info.version;
    localStorage.setItem('cached_app_version', installedVersion); // set current app version
    currentVersion.value = installedVersion;

    if (!minVersion || minVersion === '0.0.0') {
      return;
    }

    const needUpdate = isOutdated(installedVersion, minVersion);
    isUpdateRequired.value = needUpdate;
  } catch (e) {
    console.error('Version check failed', e);
    isUpdateRequired.value = false;
  }
};

const isOutdated = (current, min) => {
  const c = current.split('.').map(Number);
  const m = min.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    if ((c[i] || 0) < (m[i] || 0)) return true;
    if ((c[i] || 0) > (m[i] || 0)) return false;
  }
  return false;
};

export const openStore = () => {
  const appId = Capacitor.getPlatform() === 'ios' ? 'id6450853590' : 'app.mobile.conf.gens';
  NativeMarket.openStoreListing({ appId });
};
